import React, { useState, createContext, useContext } from 'react';
import { Dialog, Popover } from '@material-ui/core';

const DialogContext = createContext();

const DialogWithFocusProvider = ({ children, variant, ...rest }) => {
	const [disableEnforceFocus, setDisableEnforceFocus] = useState(false);

	const Component = variant === 'popover' ? Popover : Dialog;
  return (
		<DialogContext.Provider value={setDisableEnforceFocus}>
			<Component
				{...rest}
				disableEnforceFocus={disableEnforceFocus}
			>
				{children}
			</Component>
		</DialogContext.Provider>
  );
}

export default DialogWithFocusProvider;
export const useDialogFocusContext = () => useContext(DialogContext);